import {
  MessageInvoiceSigningCreate,
  MessageInvoiceSigningCreateVariables,
} from 'common/graphql/__generated__/MessageInvoiceSigningCreate';
import { HierarchyNode } from '../index';
import { GenericNodeView } from 'common/components/PreviewApprovalHierarchyReactFlow/NodeView';

import ADD_NEW_MESSAGE from 'common/graphql/MessageInvoiceSigningCreate.graphql';
interface NodeViewProps {
  data: HierarchyNode;
}

export const NodeView: React.FC<NodeViewProps> = ({ data }) => {
  return (
    <GenericNodeView<
      HierarchyNode,
      MessageInvoiceSigningCreate,
      MessageInvoiceSigningCreateVariables
    >
      data={data}
      addNewMessageMutation={ADD_NEW_MESSAGE}
      getEntityId={(data) => data.entityApprovalId!}
    />
  );
};
